var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"global-home-sr",class:{ 'global-home-sr--rail': _vm.isListCreative }},[(!_vm.isListCreative)?_c('h2',{staticClass:"global-home-sr__heading"},[_vm._v(_vm._s(_vm.$tc('WEBAPP_MODULE_MAIN_TODAYS_PICK')))]):_vm._e(),_c('div',{staticClass:"global-home-sr__ad"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }